export const formatBase64ToSrc = (base64, format = 'jpg+jpeg+png') => `data:image/${ format };${ base64 }`;
